jQuery.fn.initJsp = function(){
    const jsp = $(this).data('jsp');
    if (!jsp) {
        var params = {
            "animateScroll": true,
            "showArrows": true,
            "maintainPosition": false,
            //"autoReinitialise": false //из-за этого параметра слишком много багов,
            //типа "при скорлле автоматически прокручивается вверх", да и память он есть прилично
            //если гдето не перерисовывается скролл - надо перинициализировать его
            //в ручную используюя метод jsp.reinitialise()
            //Также постоянная реинициализация может приводить к серьёзной нагрузке на процессор
        };

        try {
            params = $.extend(params, JSON.parse($(this).attr("data-jsp-init")));
        } catch (ex) {
        }
        $(this).jScrollPane(params);
    } else {
        jsp.reinitialise();
    }
    return this;
};

jQuery.fn.reinitJsp = function(){
    this.each(function(){
        const jsp = $(this).data('jsp');
        if (jsp){
            jsp.reinitialise();
        }
    });
    return this;
};
